import { render } from "./DriversManagementDetail.vue?vue&type=template&id=02f36598&scoped=true&ts=true"
import script from "./DriversManagementDetail.vue?vue&type=script&lang=ts"
export * from "./DriversManagementDetail.vue?vue&type=script&lang=ts"

import "./DriversManagementDetail.vue?vue&type=style&index=0&id=02f36598&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f36598"]])

export default __exports__